import { useState, useEffect } from 'react';

// Simple hook to check if user is authenticated
export function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Function to get access token from cookies (client-side)
    const getAccessToken = (): string | null => {
      if (typeof document === 'undefined') return null;
      
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
        const [name, value] = cookie.trim().split('=');
        if (name === 'accessToken') {
          return decodeURIComponent(value);
        }
      }
      return null;
    };

    // Check authentication status
    const checkAuth = () => {
      const token = getAccessToken();
      setIsAuthenticated(!!token);
      setIsLoading(false);
    };

    checkAuth();

    // Listen for cookie changes (when user logs in/out)
    const interval = setInterval(checkAuth, 1000);

    return () => clearInterval(interval);
  }, []);

  return { isAuthenticated, isLoading };
} 